import Pricing from "pages/Admin/Pricing";

export default function PricingPage() {
  return <Pricing />;
}
